import { AUDIO_PARAM_STORE } from '../globals';
export const getNativeAudioParam = (audioParam) => {
    const nativeAudioParam = AUDIO_PARAM_STORE.get(audioParam);
    if (nativeAudioParam === undefined) {
        throw new Error('The associated nativeAudioParam is missing.');
    }
    return nativeAudioParam;
};
//# sourceMappingURL=/build/es2018/helpers/get-native-audio-param.js.map